import React from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import { applyClassToCharacters } from "../../../constants/const";
import "./reportKit.css";

// Shared building blocks for report screens: wrap the page in `rk-page`
// and compose these pieces. Styles live in reportKit.css.

export const ReportBackButton = () => {
  const history = useHistory();
  const Arrow = GetSelectedLanguage() === "ur" ? FaArrowRight : FaArrowLeft;
  return (
    <button
      type="button"
      className="rk-back noprint"
      onClick={() => history.goBack()}
    >
      <Arrow size={12} />
      <GetLanguageString props="unit_back_btn" />
    </button>
  );
};

export const ReportFilterCard = ({
  title,
  onSubmit,
  submitLabel,
  children,
}) => (
  <form className="rk-card rk-filter noprint" onSubmit={onSubmit}>
    <header className="rk-card-head">
      <h4>{title}</h4>
      <ReportBackButton />
    </header>
    <div className="rk-card-body">
      {children}
      <div className="rk-submit">
        <button type="submit" className="rk-btn rk-btn-primary">
          {submitLabel}
        </button>
      </div>
    </div>
  </form>
);

// Cascading unit dropdowns (one per hierarchy level). `unitList` is the
// response of ApiUnit().getUnitList and `onChange` receives the picked option.
export const UnitSelects = ({ unitList, onChange }) => (
  <div className="rk-selects">
    {unitList.map((record, index) => {
      const options = [];
      record.unitList.forEach((d) =>
        d.unitTypeName !== "Munfarid" && d.unitTypeName !== "UsraMuavin"
          ? options.push({
              value: d.id,
              label: d.name,
              label1: d.unitTypeName,
            })
          : null,
      );
      const selected =
        record.selectedUnit !== null
          ? { value: record.selectedUnit.id, label: record.selectedUnit.name }
          : {};
      const parentName = record.parentUnitName ?? "";

      return (
        <div className="rk-field" key={index}>
          <label className="rk-label">
            {parentName !== "" ? (
              <GetLanguageString
                props="member_select_unit_name"
                value={parentName}
              />
            ) : (
              <GetLanguageString props="member_select_unit" />
            )}
          </label>
          <Select
            options={options}
            value={selected}
            className="basic-single ur"
            classNamePrefix="select"
            formatOptionLabel={(option) =>
              applyClassToCharacters(option.label, "ur")
            }
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            onChange={onChange}
          />
        </div>
      );
    })}
  </div>
);

export const ReportSwitch = ({ checked, onChange, label }) => (
  <label className="rk-switch">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span className="rk-slider" />
    <span>{label}</span>
  </label>
);

export const ScopeSegments = ({ scopes, value, onChange }) => (
  <div className="rk-seg" role="group">
    {scopes.map((scope) => (
      <button
        type="button"
        key={scope.key}
        className={value === scope.key ? "rk-seg-btn active" : "rk-seg-btn"}
        onClick={() => onChange(scope.key)}
      >
        {scope.label}
      </button>
    ))}
  </div>
);

export const ReportActionButton = ({ icon, label, onClick, loading }) => (
  <button
    type="button"
    className="rk-btn rk-btn-ghost"
    onClick={onClick}
    disabled={loading}
  >
    {loading ? <span className="rk-spin" /> : icon}
    {label}
  </button>
);

export const ReportSection = ({ title, count, hint, children }) => (
  <section className="rk-card rk-section">
    <header className="rk-card-head">
      <h4>{title}</h4>
      {count !== undefined && <span className="rk-count">{count}</span>}
    </header>
    {hint && <p className="rk-hint">{hint}</p>}
    <div className="rk-card-body">{children}</div>
  </section>
);
